var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status"},[_c('b-icon',{class:("status--" + _vm.status),attrs:{"icon":"circle","size":"is-small"}}),_c('span',[_vm._v(_vm._s(_vm.$t(("registrationStatus." + _vm.status))))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }